/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ weeks: NonNullable<unknown> }} Insight_Consistency_StreakInputs */

const en_us2_insight_consistency_streak = /** @type {(inputs: Insight_Consistency_StreakInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.weeks} weeks in a row. Keep it going!`)
};

const pt_br2_insight_consistency_streak = /** @type {(inputs: Insight_Consistency_StreakInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.weeks} semanas seguidas. Continue assim!`)
};

const es_419_insight_consistency_streak = /** @type {(inputs: Insight_Consistency_StreakInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.weeks} semanas seguidas. ¡Sigue así!`)
};

const pt_pt2_insight_consistency_streak = /** @type {(inputs: Insight_Consistency_StreakInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.weeks} semanas seguidas. Continua assim!`)
};

const fr_fr2_insight_consistency_streak = /** @type {(inputs: Insight_Consistency_StreakInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.weeks} semaines d'affilée. Continue comme ça !`)
};

const de_de2_insight_consistency_streak = /** @type {(inputs: Insight_Consistency_StreakInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.weeks} Wochen am Stück. Weiter so!`)
};

const it_it2_insight_consistency_streak = /** @type {(inputs: Insight_Consistency_StreakInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.weeks} settimane di fila. Continua così!`)
};

/**
* | output |
* | --- |
* | "{weeks} weeks in a row. Keep it going!" |
*
* @param {Insight_Consistency_StreakInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const insight_consistency_streak = /** @type {((inputs: Insight_Consistency_StreakInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Insight_Consistency_StreakInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_insight_consistency_streak(inputs)
	if (locale === "es-419") return es_419_insight_consistency_streak(inputs)
	if (locale === "pt-PT") return pt_pt2_insight_consistency_streak(inputs)
	if (locale === "fr-FR") return fr_fr2_insight_consistency_streak(inputs)
	if (locale === "de-DE") return de_de2_insight_consistency_streak(inputs)
	if (locale === "it-IT") return it_it2_insight_consistency_streak(inputs)
	return en_us2_insight_consistency_streak(inputs)
});
export { insight_consistency_streak as "insight.consistency_streak" }